import React, { useRef } from "react";
import { Table, Tag, Input, Button, Space } from "antd";
import {
  SearchOutlined,
  FilterOutlined,
  PlusOutlined,
  CloseOutlined,
} from "@ant-design/icons";

const currencyFormatter = (value) =>
  value !== null && value !== undefined
    ? new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(value)
    : "-";

const dateFormatter = (value) =>
  value
    ? new Intl.DateTimeFormat("id-ID", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(new Date(value))
    : "-";

// 🔎 util untuk search di kolom
const getColumnSearchProps = (dataIndex, searchInput) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={searchInput}
        placeholder={`Cari ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() => {
          confirm();
        }}
        style={{ marginBottom: 8, display: "block" }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => {
            confirm();
          }}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Cari
        </Button>
        <Button
          onClick={() => {
            clearFilters();
            confirm();
          }}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered) =>
    filtered ? (
      <FilterOutlined style={{ color: "white" }} />
    ) : (
      <SearchOutlined style={{ color: "white" }} />
    ),
  onFilter: (value, record) =>
    record[dataIndex]
      ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
      : "",
});

const TableViewManualan = ({ data, onKirim }) => {
  const searchInput = useRef(null);

  const columns = [
    {
      title: "Action",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: 120,
      fixed: true,
      render: (_, row) => (
        <Space>
          <Button
            danger
            title="Batalkan Kirim"
            disabled={row.TFSFlag !== "1"}
            onClick={async () => {
              if (onKirim) await onKirim(row, "CANCEL TFS");
            }}
          >
            <Space>
              <CloseOutlined />
            </Space>
          </Button>
          <Button
            title="Kirim Pesanan"
            type="primary"
            disabled={row.TFSFlag === "1"}
            onClick={async () => {
              if (onKirim) await onKirim(row, "TFS");
            }}
          >
            <Space>
              <PlusOutlined />
              Kirim
            </Space>
          </Button>
        </Space>
      ),
    },
    { title: "No", dataIndex: "No", key: "No" },
    {
      title: "Nama",
      dataIndex: "Nama",
      key: "Nama",
      ...getColumnSearchProps("Nama", searchInput),
    },
    {
      title: "Target",
      dataIndex: "Target",
      key: "Target",
      ...getColumnSearchProps("Target", searchInput),
    },
    {
      title: "Tanggal Transaksi",
      dataIndex: "TglTransaksi",
      key: "TglTransaksi",
      render: dateFormatter,
      sorter: (a, b) =>
        new Date(a.TglTransaksi).getTime() - new Date(b.TglTransaksi).getTime(),
    },
    {
      title: "Sub Total",
      dataIndex: "SubTotal",
      key: "SubTotal",
      render: currencyFormatter,
      sorter: (a, b) => a.SubTotal - b.SubTotal,
    },
    {
      title: "Bayar",
      dataIndex: "Bayar",
      key: "Bayar",
      render: currencyFormatter,
      sorter: (a, b) => a.Bayar - b.Bayar,
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) =>
        record.TglBayar ? (
          <Tag color="green">Dibayar</Tag>
        ) : (
          <Tag color="red">Belum Dibayar</Tag>
        ),
    },
  ];

  return (
    <>
      <i style={{ color: "red", marginBottom: "10px", display: "block" }}>
        *Pastikan pembeli sudah membayar tagihan sebelum mengirim.
      </i>
      <Table
        scroll={{ x: "max-content" }}
        columns={columns}
        dataSource={data}
        size="middle"
      />
    </>
  );
};

export default TableViewManualan;
